import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import SelectField from "../../../../components/common/form/SelectField";
import { createOptionListForSelectTag } from "../../../../helpers/utils/Utils";
import { OptionType } from "../../../../helpers/utils/StyleUtils";

interface SubdivisionDetailInfoProps {
    subdivisionData: any;
    showButtons?: any;
    setShowButtons?: any;
    subdivisionsData?: any;
    setSubdivisionData?: any
}

const SubdivisionStatusSection: FC<SubdivisionDetailInfoProps> = ({ subdivisionData, showButtons, setShowButtons, subdivisionsData, setSubdivisionData }) => {
    const { data: enums } = useGetEnumsQuery("");


    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const { name, value } = "target" in e ? e.target : e;

        setSubdivisionData((prevData: any) => ({
            ...prevData,
            [name]: value
        }));
        setShowButtons(true);
    };

    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md">
            <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                <h5 className="font-semibold text-surface-0">Subdivision Status Section</h5>
            </div>
            <div className="x-auto p-2">
                <div className="w-full bg-text-0 p-3 border-2 border-[rgba(0,0,0,0.1)]">
                    <div className="row">
                        <div className="col-5">
                            <SelectField
                                placeholder='Select Research Status...'
                                value={subdivisionsData?.subdivisionResearchStatus ?? ""}
                                options={createOptionListForSelectTag(enums?.["SubdivisionResearchStatus"], "value", "constant")}
                                onChange={(selectedOption) => handleOnChange({ name: "subdivisionResearchStatus", value: selectedOption })}
                                label="Research Status"
                            />
                        </div>
                        <div className="col-7">
                            <SelectField
                                placeholder='Select Rollback Status...'
                                value={subdivisionsData?.subdivisionRollbackStatus ?? ""}
                                options={createOptionListForSelectTag(enums?.["SubdivisionRollbackStatus"], "value", "constant")}
                                onChange={(selectedOption) => handleOnChange({ name: "subdivisionRollbackStatus", value: selectedOption })}
                                label="Rollback Status"
                            />
                        </div>
                        <div className="col-7">
                             <SelectField
                                 placeholder='Select End of Year Status...'
                                 value={subdivisionsData?.endOfYearStatus ?? ""}
                                 options={createOptionListForSelectTag(enums?.["EndOfYearStatus"], "value", "constant")}
                                 onChange={(selectedOption) => handleOnChange({ name: "endOfYearStatus", value: selectedOption })}
                                 label="End of Year Status"
                             />
                         </div>

                        <div className="col-7">
                            <SelectField
                                placeholder='Select Association Presence...'
                                value={subdivisionsData?.associationPresence ?? ""}
                                options={createOptionListForSelectTag(enums?.["AssociationPresence"], "value", "constant")}
                                onChange={(selectedOption) => handleOnChange({ name: "associationPresence", value: selectedOption })}
                                label="Association Presence"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubdivisionStatusSection;